// import axios from 'axios';
import axiosInstance from './axiosInstance';
import axios from 'axios';
import { OK_STATUS_CODE } from './constants';
import { sortTypeMapper } from '../utils/sorting';
import fileUploadApi from './fileUploadInstance';
import { APP_USER_TYPES } from '../appContants';
import { API_ENDPOINTS } from './apiEndpoints';

// Uncomment the following line if you're using API_BASE_URL
const API_BASE_URL =
  'https://jf8gh0609g.execute-api.us-east-1.amazonaws.com/dev';

const apiService = {
  // Users
  async getUserProfile() {
    try {
      const response = await axiosInstance.get(API_ENDPOINTS.userProfile);
      return response?.data?.data; // Return only the data, not the entire response object
    } catch (error) {
      return undefined;
    }
  },
  async updateUserProfile(data) {
    const response = await axiosInstance.put(API_ENDPOINTS.userProfile, data);
    if (response?.status === OK_STATUS_CODE) {
      return response?.data?.data;
    }
    return response;
  },
  async getAllUsers(associationtype = APP_USER_TYPES.clinicUser) {
    try {
      const response = await axiosInstance.get(
        // TODO: remove static limit
        // handle through input search (paginated list)
        '/clinic/user/staff?limit=100&page=1',
        {
          params: {
            associationtype,
          },
        }
      );
      return response?.data?.data; // Return only the data, not the entire response object
    } catch (error) {
      console.log('Error fetching users:', error); // Log the specific error message
      return;
    }
  },
  async getAllClinicUserDropdownList(data) {
    console.log('data', data);
    try {
      const response = await axiosInstance.get(
        '/cms/clinic/staff/dropdown-list',
        {
          params: {
            limit: data?.limit,
            page: data?.page,
            cmsClinicLocationId: data?.clinicLocationId,
            search: data?.search,
          },
        }
      );
      return response?.data?.data;
    } catch (error) {
      return {
        items: [],
      }
    }
  },
  async inviteUser(data) {
    const response = await axiosInstance.post(
      '/cms/user/radiologist/invitation',
      data
    );
    return response; // Return only the data, not the entire response object
  },
  async updateStaff(data) {
    const response = await axiosInstance.put(
      '/cms/user/radiologist/update',
      data
    );
    if (response?.status === OK_STATUS_CODE) {
      return response?.data?.data;
    }
    return response;
  },
  async getInvitedUser(id) {
    const res = await axios.get(
      // TODO: need to remove this manually inserted base URL
      `${API_BASE_URL}/cms/user/radiologist/invitation/${id}`
    );
    return res;
  },
  async signUPUser(cognitoUser) {
    try {
      const res = await axios.post(
        `${API_BASE_URL}/radiologist/auth/user-signup`,
        cognitoUser
      );
      return res; // Return only the data, not the entire response object
    } catch (error) {
      console.log('Error :', error); // Log the specific error message
      throw error;
    }
  },
  async confirmSignupClinic(cognitoUser) {
    try {
      const res = await axios.post(
        `${API_BASE_URL}/radiologist/auth/signup-confirmation`,
        cognitoUser
      );
      return res; // Return only the data, not the entire response object
    } catch (error) {
      console.log('Error :', error); // Log the specific error message
      return false;
    }
  },
  async userList(params, associationtype = APP_USER_TYPES.clinicUser) {
    try {
      const response = await axiosInstance.get('/clinic/user/staff', {
        params: {
          associationtype,
          limit: params.limit,
          page: params.page,
          clinicId: params.clinicId,
          search: params.search,
          sortBy: params.sortBy,
          sortOrder: sortTypeMapper(params.sortOrder),
        },
      });
      return response?.data?.data; // Return only the data, not the entire response object
    } catch (error) {
      console.log('Error fetching users:', error); // Log the specific error message
      return false;
    }
  },
  async getAllActiveRadiologist() {
    try {
      const response = await axiosInstance.get(
        // TODO: remove static limit
        // handle through input search (paginated list)
        '/cms/user/radiologist?limit=100&page=1'
      );
      return response?.data?.data; // Return only the data, not the entire response object
    } catch (error) {
      console.log('Error fetching radiologist:', error); // Log the specific error message
      return;
    }
  },
  // Radiologist
  // TODO: need to fetch all radiologist invited & registered
  async getAllRadiologist(params) {
    try {
      const response = await axiosInstance.get('/cms/user/radiologist/all', {
        params: {
          limit: params.limit,
          page: params.page,
          search: params.search,
          sortBy: params.sortBy,
          sortOrder: sortTypeMapper(params.sortOrder),
        },
      });
      return response?.data?.data; // Return only the data, not the entire response object
    } catch (error) {
      console.log('Error fetching radiologist:', error); // Log the specific error message
      return;
    }
  },
  async assignCaseToRadioLogist(caseId, data) {
    const res = await axiosInstance.patch(
      `${API_BASE_URL}${API_ENDPOINTS.cmsCasesBase}/${caseId}/assign`,
      data
    );
    return res;
  },
  async assignBulkCaseToRadioLogist(caseIds, data) {
    const res = await axiosInstance.patch(
      `${API_BASE_URL}${API_ENDPOINTS.cmsCasesBase}/bulk-assign`,
      { ...data, caseIds }
    );
    return res;
  },
  async unAssignCaseToRadioLogist(caseId) {
    const res = await axiosInstance.patch(
      `${API_BASE_URL}${API_ENDPOINTS.cmsCasesBase}/${caseId}/unassign`
    );
    return res;
  },
  async acceptCaseFromRadioLogist(caseId) {
    const res = await axiosInstance.patch(
      `${API_BASE_URL}${API_ENDPOINTS.cmsCasesBase}/${caseId}/accept`
    );
    return res;
  },
  async rejectCaseFromRadioLogist(caseId) {
    const res = await axiosInstance.patch(
      `${API_BASE_URL}${API_ENDPOINTS.cmsCasesBase}/${caseId}/reject`
    );
    return res;
  },
  async resolveCaseFromRadioLogist(caseId) {
    const res = await axiosInstance.patch(
      `${API_BASE_URL}${API_ENDPOINTS.cmsCasesBase}/${caseId}/resolve`
    );
    return res;
  },
  // Auth
  async signUPClinic(cognitoUser) {
    try {
      const res = await axiosInstance.post('/clinic/auth/signup', cognitoUser);
      return res; // Return only the data, not the entire response object
    } catch (error) {
      console.log('Error :', error); // Log the specific error message
      return false;
    }
  },
  async callme() {
    try {
      const response = await axiosInstance.get(API_ENDPOINTS.callMe);
      return response; // Return only the data, not the entire response object
    } catch (error) {
      throw new Error('Error fetching user'); // Rethrow the error
    }
  },
  // Branches
  async branchList(params) {
    try {
      const response = await axiosInstance.get('/clinic/locations', {
        params: {
          limit: params.limit,
          page: params.page,
          clinicId: params.clinicId,
          search: params.search,
          sortBy: params.sortBy,
          sortOrder: sortTypeMapper(params.sortOrder),
        },
      });
      return response?.data?.data;
    } catch (error) {
      return [];
    }
  },
  async createBranch(data, params) {
    const response = await axiosInstance.post(`/clinic/locations/`, data, {
      params,
    });
    if (response?.status === OK_STATUS_CODE) {
      return response?.data?.data;
    }
    return response;
  },
  // Cases
  async caseList(params) {
    try {
      const response = await axiosInstance.get(API_ENDPOINTS.cmsCasesBase, {
        params: {
          limit: params.limit,
          page: params.page,
          ...(params.search ? { search: params.search } : {}),
          sortBy: params.sortBy,
          sortOrder: sortTypeMapper(params.sortOrder),
          caseStatus: params.caseStatus,
          hasRush:params.hasRush?params.hasRush:null,
          caseReviewStatus:params.proStatus !== 'all' ? params.proStatus : undefined,
        },
      });
      return response?.data?.data;
    } catch (error) {
      return [];
    }
  },
  async getCase(id) {
    try {
      const response = await axiosInstance.get(
        `${API_ENDPOINTS.cmsCasesBase}/${id}`
      );
      return response?.data?.data;
    } catch (error) {
      return;
    }
  },
  async getCaseReportTemplate(id) {
    try {
      const response = await axiosInstance.get(
        `${API_ENDPOINTS.cmsCasesBase}/${id}/report-template`
      );
      return response?.data?.data;
    } catch (error) {
      return;
    }
  },
  async getCaseFile(id, objectKey, fileName) {
    try {
      const response = await axiosInstance.get(
        `${API_ENDPOINTS.cmsCasesBase}/${id}/files`,
        {
          params: { objectKey, fileName },
        }
      );
      return response?.data?.data;
    } catch (error) {
      return;
    }
  },
  async getPresignedUrl(data) {
    const response = await axiosInstance.post(
      `${API_ENDPOINTS.cmsCasesBase}/files`,
      data
    );
    return response?.data?.data;
  },
  async getPresignedForProfileUrl(data) {
    const response = await axiosInstance.post(
      `/cms/user/profile/photo`,
      data
    );
    return response?.data?.data;
  },
  async uploadWithPresignedUrl(url, data, onProgress) {
    return await fileUploadApi.post(url, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: ({ total, loaded }) => {
        onProgress?.({ percent: Math.round((loaded / total) * 100) });
      },
    });
  },
  async createCase(data, params) {
    const response = await axiosInstance.post(
      `${API_ENDPOINTS.cmsCasesBase}`,
      data,
      {
        params,
      }
    );
    if (response?.status === OK_STATUS_CODE) {
      return response?.data;
    }
    return response;
  },
  async updateCase(id, data, params) {
    const response = await axiosInstance.put(
      `${API_ENDPOINTS.cmsCasesBase}/${id}`,
      data,
      {
        params,
      }
    );
    if (response?.status === OK_STATUS_CODE) {
      return response?.data;
    }
    return response;
  },
  async deleteCase(id) {
    const response = await axiosInstance.delete(
      `${API_ENDPOINTS.cmsCasesBase}/${id}`
    );
    if (response?.status === OK_STATUS_CODE) {
      return response?.data;
    }
    return response;
  },
  async bulkDeleteCase(caseIds) {
    const response = await axiosInstance.post(
      `${API_ENDPOINTS.cmsCasesBase}/bulk-delete`,
      {
        caseIds,
      }
    );
    if (response?.status === OK_STATUS_CODE) {
      return response?.data;
    }
    return response;
  },
  // Case Services
  async servicesList(clinicLocationId) {
    try {
      const response = await axiosInstance.get(`${API_ENDPOINTS.cmsMaster}/clinic-location-service-charges`, {
        params: {
          clinicLocationId,
        },
      });
      return response?.data?.data;
    } catch (error) {
      return;
    }
  },
  async updateServiceCharges(data) {
    const response = await axiosInstance.put(
      `${API_ENDPOINTS.cmsMaster}/clinic-location-service-charges`,
      data
    );
    if (response?.status === OK_STATUS_CODE) {
      return response?.data;
    }
    return response;
  },
  // Clinic Master
  async getAllClinics(params) {
    try {
      const response = await axiosInstance.get('/cms/clinic', {
        params: {
          limit: params.limit,
          page: params.page,
          search: params.search,
          sortBy: params.sortBy,
          sortOrder: sortTypeMapper(params.sortOrder),
          status:params.statusFilter,
        },
      });
      return response?.data?.data; // Return only the data, not the entire response object
    } catch (error) {
      console.log('Error fetching radiologist:', error); // Log the specific error message
      return;
    }
  },
  async getClinic(id) {
    try {
      const response = await axiosInstance.get(`${'/cms/clinic'}/${id}`);
      return response?.data?.data;
    } catch (error) {
      return;
    }
  },
  async getClinicOnwers() {
    try {
      const response = await axiosInstance.get('/cms/clinic/owners');
      return response?.data?.data;
    } catch (error) {
      return;
    }
  },
  async deleteClinic(clinicId) {
    const response = await axiosInstance.delete(`/cms/clinic/${clinicId}`);
    if (response?.status === OK_STATUS_CODE) {
      return response?.data?.data;
    }
  },
  async updateClinicStatus(id, status) {
    try {
      const response = await axiosInstance.put(
        `${'/cms/clinic'}/${id}/status`,
        { status }
      );
      return response?.data?.data;
    } catch (error) {
      return;
    }
  },
  async updateClinicLocation(clinicId, clinicLocationId, data) {
    const response = await axiosInstance.put(
      `/cms/clinic/${clinicId}/location/${clinicLocationId}`,
      data
    );
    if (response?.status === OK_STATUS_CODE) {
      return response?.data?.data;
    }
  },
  // Add more API functions as needed

  // Invoice master
  async getAllInvoices(params) {
    try {
      const response = await axiosInstance.get('/cms/invoices', {
        params: {
          limit: params.limit,
          page: params.page,
          search: params.search,
          sortBy: params.sortBy,
          sortOrder: sortTypeMapper(params.sortOrder),
        },
      });
      return response?.data?.data; // Return only the data, not the entire response object
    } catch (error) {
      console.log('Error fetching radiologist:', error); // Log the specific error message
      return;
    }
  },
  async getInvoicesReportList(params) {
    try {
      const response = await axiosInstance.get('/cms/invoices/invoice-report', {
        params: {
          limit: params?.limit,
          page: params?.page,
          search: params?.search,
          sortBy: params?.sortBy,
          sortOrder: sortTypeMapper(params.sortOrder),
          invoiceType: params?.invoiceType,
          invoiceMonth: params?.invoiceMonth,
          invoiceYear: params?.invoiceYear,
          doctorSub: params?.doctorSub,
        },
      });
      return response?.data?.data; // Return only the data, not the entire response object
    } catch (error) {
      console.log('Error fetching radiologist:', error); // Log the specific error message
      return;
    }
  },
  async markInvoiceAsPaid(invoiceId) {
    const response = await axiosInstance.patch(
      `${'/cms/invoices'}/${invoiceId}/mark-as-paid-by-cheque`
    );
    return response?.data?.data;
  },
  async getInvoice(id) {
    try {
      const response = await axiosInstance.get(`${'/cms/invoices'}/${id}`);
      return response?.data?.data;
    } catch (error) {
      return;
    }
  },
  async updateInvoiceStatus(id, status) {
    try {
      const response = await axiosInstance.put(
        `${'/cms/invoices'}/${id}/status`,
        { status }
      );
      return response?.data?.data;
    } catch (error) {
      return;
    }
  },
  async updateInvoice(id, data) {
    const response = await axiosInstance.put(`${'/cms/invoices'}/${id}`, data);
    if (response?.status === OK_STATUS_CODE) {
      return response?.data?.data;
    }
  },
  async createInvoice(data) {
    const response = await axiosInstance.post(`${'/cms/invoices'}`, data);
    if (response?.status === OK_STATUS_CODE) {
      return response?.data?.data;
    }
  },
  async deleteInvoiceService(invoiceId, invoiceServiceId) {
    const response = await axiosInstance.delete(
      `${'/cms/invoices'}/${invoiceId}/${invoiceServiceId}`
    );
    if (response?.status === OK_STATUS_CODE) {
      return response?.data?.data;
    }
  },
  async restoreInvoiceService(invoiceId, invoiceServiceId) {
    const response = await axiosInstance.patch(
      `${'/cms/invoices'}/${invoiceId}/${invoiceServiceId}`
    );
    if (response?.status === OK_STATUS_CODE) {
      return response?.data?.data;
    }
  },
  async downloadInvoicePreview(invoiceId) {
    const response = await axiosInstance.get(
      `${'/cms/invoices'}/${invoiceId}/download-invoice-preview`
    );
    if (response?.status === OK_STATUS_CODE) {
      return response?.data?.data;
    }
  },
  async sendInvoiceEmail(invoiceId, data) {
    const response = await axiosInstance.post(
      `${'/cms/invoices'}/${invoiceId}/send-email`,
      data
    );
    if (response?.status === OK_STATUS_CODE) {
      return response?.data?.data;
    }
  },
  async createMonthlyCaseInvoices(data) {
    const response = await axiosInstance.post(
      `${'/cms/invoices'}/invoice-monthly`,
      data
    );
    if (response?.status === OK_STATUS_CODE) {
      return response?.data?.data;
    }
  },
  // Radiologist Invoice
  async getRadiologistInvoiceList(params) {
    try {
      const response = await axiosInstance.get('/cms/radiologist-invoices', {
        params: {
          limit: params.limit,
          page: params.page,
          search: params.search,
          sortBy: params.sortBy,
          sortOrder: sortTypeMapper(params.sortOrder),
        },
      });
      return response?.data?.data; // Return only the data, not the entire response object
    } catch (error) {
      console.log('Error fetching radiologist invoice list:', error); // Log the specific error message
      return;
    }
  },
  async getRadiologistInvoice(id) {
    try {
      const response = await axiosInstance.get(
        `${'/cms/radiologist-invoices'}/${id}`
      );
      return response?.data?.data;
    } catch (error) {
      return;
    }
  },
  async createCustomDurationInvoices(data) {
    const response = await axiosInstance.post(
      `${'/cms/radiologist-invoices'}/invoice-monthly`,
      data
    );
    if (response?.status === OK_STATUS_CODE) {
      return response?.data?.data;
    }
  },
  async updateRadiologistInvoice(id, data) {
    const response = await axiosInstance.put(
      `${'/cms/radiologist-invoices'}/${id}`,
      data
    );
    if (response?.status === OK_STATUS_CODE) {
      return response?.data?.data;
    }
  },
  async updateRadiologistInvoicePaymentStatus(id, data) {
    const response = await axiosInstance.patch(
      `${'/cms/radiologist-invoices'}/${id}/update-payment-status`,
      data
    );
    if (response?.status === OK_STATUS_CODE) {
      return response?.data?.data;
    }
  },
  async downloadRadiologistInvoicePreview(invoiceId) {
    const response = await axiosInstance.get(
      `${'/cms/radiologist-invoices'}/${invoiceId}/download-invoice-preview`
    );
    if (response?.status === OK_STATUS_CODE) {
      return response?.data?.data;
    }
  },
  async sendRadiologistInvoiceEmail(invoice) {
    const response = await axiosInstance.get(
      `${'/cms/radiologist-invoices'}/${invoice}/send-email`
    );
    if (response?.status === OK_STATUS_CODE) {
      return response?.data?.data;
    }
  },
  async getInvoiceFooter(data) {
    const response = await axiosInstance.get('/cms/invoices/footer', data);
    if (response?.status === OK_STATUS_CODE) {
      return response?.data?.data;
    }
  },
  async updateInvoiceFooter(data) {
    const response = await axiosInstance.put('/cms/invoices/footer', data);
    if (response?.status === OK_STATUS_CODE) {
      return response?.data?.data;
    }
  },
  // Dashboard API requests
  async getDashboard(params) {
    try {
      const response = await axiosInstance.get('/cms/cases/dashboard', {
        params: {
          startDate: params?.startDate,
          endDate: params?.endDate,
        },
      });
      return response?.data?.data; // Return only the data, not the entire response object
    } catch (error) {
      console.log('Error fetching dashboard list:', error); // Log the specific error message
      return;
    }
  },
  // Bulk Assign Clinics
  async bulkApprovedClinic(clinicIds) {
    const response = await axiosInstance.put('/cms/clinic/bulk-status', {
      clinicIds,
      status:'APPROVED'
    });
    if (response?.status === OK_STATUS_CODE) {
      return response?.data;
    }
    return response;
  },

  // Bulk Delete Clinics
  async bulkDeleteClinic(clinicIds) {
    const response = await axiosInstance.post('/cms/clinic/bulk-delete', {
      clinicIds,
    });
    if (response?.status === OK_STATUS_CODE) {
      return response?.data;
    }
    return response;
  },
};

export default apiService;
